import ts from 'typescript';
import { getText } from './node';
export function getLiteralValue(node) {
    if (ts.isStringLiteral(node)) {
        return node.text;
    }
    if (ts.isNumericLiteral(node)) {
        return parseInt(node.text, 10);
    }
    if (ts.isLiteralExpression(node) || ts.isTemplateHead(node) || ts.isTemplateMiddle(node) || ts.isTemplateTail(node)) {
        return node.text;
    }
    if (ts.isPrivateIdentifier(node)) {
        return getText(node);
    }
    throw new Error('Never');
}

//# sourceMappingURL=literal.js.map
